export default __webpack_public_path__ + "static/media/esquinero3.c0cf353e.png";